(function($) {
  // second smallest jquery plugin of the world ;-)
  $.fn.exists = function () {
    return this.length > 0;
  };
})(window.rossel.jquery);
